<template>
  <vs-card v-if="showComponent">
    <div slot="header">
      <h3>Carro Reserva</h3>
    </div>

    <div class="vx-row">
      <!-- Solicitou carro -->
      <div class="vx-col w-full mb-2">
        <label for class="vs-input--label">Solicitou carro</label>
        <vs-switch
          v-model="formCarroReserva.solicitaCarroReserva"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>
    </div>

    <div class="vx-row mt-4" v-if="formCarroReserva.solicitaCarroReserva">
      <!-- Data de liberação -->
      <div class="vx-col lg:w-1/3 xl:w-1/3 w-full mb-2">
        <label for class="vs-input--label">Data de liberação</label>
        <div class="inputData">
          <flat-pickr
            :config="configdateTimePickerDay"
            v-model="formCarroReserva.carroReservaDataLiberacao"
            placeholder="DD/MM/AAAA"
            name="Data de liberação"
          />
        </div>
      </div>

      <!-- Tempo de liberação -->
      <div class="vx-col lg:w-1/3 xl:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Tempo de liberação (em dias)"
          type="number"
          v-model="formCarroReserva.carroReservaQtdDias"
          name="Tempo de liberação"
          @change="onChangeTempoLiberacaoCarroReserva($event.target.value)"
          v-validate="{ required: true }"
        />
      </div>

      <!-- Data de devolução -->
      <div class="vx-col lg:w-1/3 xl:w-1/3 w-full mb-2">
        <label for class="vs-input--label">Data de devolução</label>
        <div class="inputData">
          <flat-pickr
            :config="configdateTimePickerDay"
            disabled
            v-model="formCarroReserva.carroReservaDataDevolucao"
            placeholder="DD/MM/AAAA"
            name="Data de devolução"
          />
        </div>
      </div>
    </div>

    <!-- Observações sobre carro reserva -->
    <div class="vx-row mt-4">
      <div class="vx-col w-full">
        <vs-textarea
          label="Observações sobre carro reserva"
          v-model="formCarroReserva.carroReservaObservacao"
        />
      </div>
    </div>
  </vs-card>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import moment from 'moment';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';

export default {
  props: ['formData'],
  watch: {
    formData(value) {
      if (!value.carroReserva) {
        this.showComponent = false;
        console.error('ERRO NO CONTRATO DO OBJETO - CARRO RESERVA FORM');
        return;
      }

      this.formCarroReserva = Object.assign(
        this.formCarroReserva,
        value.carroReserva,
      );

      // eslint-disable-next-line vue/no-mutating-props
      this.formData.carroReserva = this.formCarroReserva;
    },
  },
  components: {
    flatPickr,
  },
  data() {
    return {
      showComponent: true,
      formCarroReserva: {
        solicitaCarroReserva: false,
        carroReservaDataLiberacao: null,
        carroReservaQtdDias: null,
        carroReservaDataDevolucao: null,
        carroReservaObservacao: null,
      },

      // Configurações de Component
      configdateTimePickerDay: {
        dateFormat: 'd/m/Y',
        locale: Portuguese,
        time_24hr: true,
      },
    };
  },
  methods: {
    onChangeTempoLiberacaoCarroReserva(value) {
      const quantidadeDias = parseInt(value) || 0;

      if (this.formCarroReserva.carroReservaDataLiberacao) {
        const datetimeFormat = 'DD/MM/AAAA HH:mm';
        const isInUTC =
          this.formCarroReserva.carroReservaDataLiberacao.includes('Z');
        const momentFormat = isInUTC ? undefined : datetimeFormat;

        this.formCarroReserva.carroReservaDataDevolucao = moment(
          this.formCarroReserva.carroReservaDataLiberacao,
          momentFormat,
        )
          .add('days', quantidadeDias)
          .format(datetimeFormat);
      }
    },
  },
  mounted() {
    if (!this.formData.carroReserva) {
      console.error('ERRO NO CONTRATO DO OBJETO - CARRO RESERVA FORM');
      this.showComponent = false;
    }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.carroReserva = this.formCarroReserva;
  },
};
</script>
